import { format, parse } from 'date-fns';
import { da, enUS } from 'date-fns/locale';
import { formatInTimeZone } from 'date-fns-tz';

const FORMAT = 'yyyy-MM-dd';
const FORMAT_PRETTY = 'EEEE, MMMM do yyyy';
const FORMAT_WITH_TIME = 'd MMM yyyy - HH:mm';
const FORMAT_EVENT_DATE = "MMM d 'at' HH:mm";
const TIMEZONE_COPENHAGEN = 'Europe/Copenhagen';

const formatDate = (date: Date) => {
  return format(date, FORMAT);
};

const formatDatePretty = (date: Date) => {
  return format(date, FORMAT_PRETTY);
};

const formatDateWithTime = (date: Date) => {
  return format(new Date(date), FORMAT_WITH_TIME);
};

const formatEventDate = (
  date: Date | string | null | undefined,
  locale: string = 'en-US'
) => {
  if (!date) return '';
  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) return '';
  const dateFnsLocale = locale.startsWith('da') ? da : enUS;
  return formatInTimeZone(dateObj, TIMEZONE_COPENHAGEN, FORMAT_EVENT_DATE, {
    locale: dateFnsLocale,
  });
};

const parseDate = (date: string) => {
  return parse(date, FORMAT, new Date());
};

export {
  formatDate,
  parseDate,
  formatDatePretty,
  formatDateWithTime,
  formatEventDate,
};
